import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import download from "../../assets/download.png";
import upload from "../../assets/upload.png";
import ActivateCard from "../../Components/Cards/ActivateCard/ActivateCard";
import DeleteCard from "../../Components/Cards/DeleteCard/DeleteCard";
import UploadMaster from "../../Components/Cards/UploadMaster/UploadMaster";
import Teacher_Form from "../../Components/Forms/Teacher/Teacher_Form";
import GeneratePassword from "../../Components/GeneratePassword/GeneratePassword";
import { useSearch } from "../../context/SearchContext";
import api from "../../utils/api";
import "./Teacher.css";

const tempData = [
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
  {
    id: "#001234",
    name: "Fanny Siregar",
    email: "test@mmhs.com",
    phone: "987456123",
  },
];

const Teacher = () => {
  const { search } = useSearch();
  const [id, setId] = useState();
  const [gr, setGr] = useState();
  const [display, setDiplay] = useState(0);
  const [status, setStatus] = useState("");
  const [data, setData] = useState([]);
  const [isModal, setIsModal] = useState(0);
  const [display1, setDisplay1] = useState(0);
  const [editData, setEditData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  // fetch(`${process.env.REACT_APP_BASE_URL}/teachers`)
  //   .then((response) => response.json())
  //   .then((data) => {
  //     setData(data);
  //   });
  //     useEffect(() => {
  //   api
  //     .get("/teachers")
  //     .then((response) => (response = response.data))
  //     .then((data) => {
  //       console.log(data);
  //       setData(data);
  //     });
  // }, []); 22/5

  // For delete confirmation modal
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  //fetch teahers data
  const fetchTeachers = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `/teachers?search=${search}&page=${pagination.page}&limit=${pagination.limit}`
      );
      setData(response.data.data);
      setPagination(response.data.pagination);
    } catch (error) {
      toast.error("Failed to fetch teachers data!");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTeachers();
  }, [search, pagination.page, pagination.limit]);

  const handleDownload = async () => {
    // const fileName = "teachers.csv";
    // fetch(`${process.env.REACT_APP_BASE_URL}/teachers/download`, {
    //   method: "GET",
    //   headers: {
    //     "Content-Type": "application/json",
    //     // Security Headers if needed
    //   },
    //   body: undefined,
    // })
    //   .then((data) => {
    //     return data.blob();
    //   })
    //   .then((data) => {
    //     if (data.size === 0) {
    //       throw new Error("File not found");
    //     }
    //     const fileURL = URL.createObjectURL(data);
    //     const downloadLink = document.createElement("a");
    //     downloadLink.href = fileURL;
    //     downloadLink.download = fileName;
    //     downloadLink.click();
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    try {
      const fileName = "teachers.csv";

      const response = await api.get("/teachers/download", {
        responseType: "blob", // Ensure the response is treated as a Blob for file download
      });

      if (response.data.size === 0) {
        throw new Error("File not found");
      }

      // Create a temporary URL for the downloaded file
      const fileURL = URL.createObjectURL(response.data);

      // Create an anchor element and trigger a download
      const downloadLink = document.createElement("a");
      downloadLink.href = fileURL;
      downloadLink.download = fileName;
      downloadLink.click();

      // Clean up the URL object after use
      URL.revokeObjectURL(fileURL);
      toast.success("Teachers master downloaded successfully!");
    } catch (error) {
      toast.error("Error downloading the file!");
      console.error("Error downloading the file:", error);
    }
  };
  // Upload Master handler (callback for UploadMaster)
  const handleUploadSuccess = (mail) => {
    setIsUpload(false);
    fetchTeachers();
    // Show toast and mail info
    toast.success(
      <>
        Teachers master uploaded successfully!
        {mail && (
          <div>
            <b>Mail sent to:</b> {mail}
          </div>
        )}
      </>
    );
  };

  // Activate all students
  const activateAll = async () => {
    await api
      .get(`/teachers/activate`)
      .then((response) => response.data)
      .then((data) => {
        fetchTeachers();
        setOpen(false);
        toast.success("All teachers activated!");
      })
      .catch(() => toast.error("Failed to activate all teachers!"));
  };

  const handleStatus = async () => {
    await api.put(`/teachers/status/${id}`, {
      status: status === "active" ? "inactive" : "active",
    });
    setIsModal(0);
    fetchTeachers();
    toast.success("Status updated!");
  };

  // Deactivate all students
  const deactivateAll = async () => {
    await api
      .get(`/teachers/deactivate`)
      .then((response) => response.data)
      .then((data) => {
        fetchTeachers();
        setOpen2(false);
        toast.success("All teachers deactivated!");
      })
      .catch(() => toast.error("Failed to deactivate all teachers!"));
  };

  // Edit handler (after edit, refresh data)
  const handleEditSuccess = () => {
    fetchTeachers();
    setDisplay1(0);
    setIsEdit(false);
    // toast.success("Teacher details updated successfully!");
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  //delete teacher handle
  // Open delete confirmation modal
  const handleDeleteClick = (teacherId) => {
    setDeleteId(teacherId);
    setDeleteModal(true);
  };

  // Confirm delete
  const handleDeleteConfirm = async () => {

    await api.delete(`/teachers/delete/${deleteId}`);
    setDeleteId(0);
    setDeleteModal(false);
    toast.success("Teacher deleted successfully");
    fetchTeachers();
  };

  // Cancel delete
  const handleDeleteCancel = () => {
    setDeleteModal(false);
    setDeleteId(null);
  };

  return (
    <div className="teacher">
      {display ? (
        <GeneratePassword
          setDisp={() => {
            setDiplay(0);
          }}
          id={id}
          gr={gr}
          role="teachers"
        />
      ) : null}
      {isUpload ? (
        <UploadMaster
          table="teachers"
          close={() => {
            setIsUpload(false);
          }}
          //change add
          onSuccess={handleUploadSuccess}
        />
      ) : null}
      {display1 ? (
        // <Teacher_Form
        //   setDisp={() => {
        //     setDisplay1(0);
        //   }}
        //   onSuccess={() => {
        //     api
        //       .get("/teachers")
        //       .then((response) => (response = response.data))
        //       .then((data) => {
        //         console.log(data);
        //         setData(data);
        //       });
        //   }}
        //   data={editData}
        //   isEdit={isEdit}
        //   setEdit={() => {
        //     setIsEdit(false);
        //   }}
        // />
        <Teacher_Form
          setDisp={() => {
            setDisplay1(0);
          }}
          onSuccess={handleEditSuccess}
          data={editData}
          isEdit={isEdit}
          setEdit={() => {
            setIsEdit(false);
          }}
        />
      ) : null}
      <div className="teacher__top">
        <div className="teacher__top_button">
          <button
            type="button"
            className="teacher__top_button_button"
            onClick={() => {
              setIsUpload(true);
            }}
          >
            <img
              className="teacher__top_button_img"
              src={upload}
              alt="upload"
            />
            Upload Master
          </button>
        </div>
        <div className="teacher__top_button">
          <button
            type="button"
            className="teacher__top_button_button"
            onClick={handleDownload}
            style={{ width: "200px" }}
          >
            <img
              className="teacher__top_button_img"
              src={download}
              alt="upload"
            />
            Download Master
          </button>
        </div>
        <div className="student__top_button">
          <button
            type="button"
            className="student__top_button_button"
            onClick={() => {
              setOpen(true);
            }}
          >
            Activate All
          </button>
        </div>
        <div className="student__top_button">
          <button
            type="button"
            className="student__top_button_button"
            onClick={() => {
              setOpen2(true);
            }}
          >
            Deactivate All
          </button>
        </div>
      </div>
      <div className="teacher__middle">
        <table>
          <thead>
            <tr className="teacher__middle_tr">
              <th className="teacher__middle_th">Teacher Id</th>
              <th className="teacher__middle_th">Teacher Name</th>
              <th className="teacher__middle_th">Teacher E-mail</th>
              <th className="teacher__middle_th">Teacher's Phone</th>
              <th className="teacher__middle_th">Gender</th>
              <th className="teacher__middle_th"></th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : data && data.length > 0 ? (
              data.map((data, idx) => (
                <tr className="teacher__middle_tr" key={data.teacher_id || idx}>
                  <td className="teacher__middle_td">
                    {data.teacher_id ? data.teacher_id.toUpperCase() : "-"}
                  </td>

                  <td className="teacher__middle_td">
                    {data.name ? data.name.toUpperCase() + " " + data.surname.toUpperCase() : "-"}
                  </td>

                  <td className="teacher__middle_td banner">
                    {data.email ? data.email.toUpperCase() : "-"}
                  </td>

                  <td className="teacher__middle_td">
                    {data.phone ? data.phone.toUpperCase() : "-"}
                  </td>

                  <td className="teacher__middle_td">
                    {data.gender ? data.gender.toUpperCase() : "-"}
                  </td>

                  <td
                    className="teacher__middle_td teacher__middle_td_gp"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="student__middle_td_activate"
                      style={
                        data.status === "active"
                          ? { backgroundColor: "#1eae7a" }
                          : { backgroundColor: "#cb444a" }
                      }
                      onClick={() => {
                        console.log("Clicked status change for ID:", data.id);

                        setId(data.id);
                        setIsModal(1);
                        setStatus(data.status);
                      }}
                    >
                      <a href="#" style={{ margin: 0 }}>
                        {data.status ? (data.status === "active" ? "Active" : "Deactive") : "-"}
                      </a>
                    </div>

                    <div style={{ marginLeft: "10px" }}>
                      <button
                        type="button"
                        className="circular__middle_td_edit"
                        onClick={() => {
                          setIsEdit(true);
                          setEditData(data);
                          setDisplay1(1);
                        }}
                      >
                        Edit
                      </button>
                    </div>

                    <div style={{ marginLeft: "10px" }}>
                      <button
                        type="button"
                        className="circular__middle_td_edit"
                        style={{
                          background: "#cb444a",
                        }}
                        onClick={() => handleDeleteClick(data.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isModal ? (
        <ActivateCard
          action={handleStatus}
          msg="Are you sure you want to change the status of the teacher ?"
          close={() => {
            setIsModal(0);
          }}
        />
      ) : null}
      {open ? (
        <DeleteCard
          btn="Proceed"
          del={activateAll}
          msg="Are you sure you want to activate all teachers ?"
          close={() => {
            setOpen(0);
          }}
        />
      ) : null}
      {open2 ? (
        <DeleteCard
          btn="Proceed"
          del={deactivateAll}
          msg="Are you sure you want to deactivate all teachers ?"
          close={() => {
            setOpen2(0);
          }}
        />
      ) : null}

      {/* ===== Delete Confirmation Modal for Single Teacher ===== */}
      {deleteModal ? (
        <DeleteCard
          btn="Delete"
          del={handleDeleteConfirm}
          msg="Are you sure you want to delete this teacher?"
          close={handleDeleteCancel}
        />
      ) : null}

      {/* Pagination Controls */}
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor:
              pagination.page === pagination.totalPages
                ? "not-allowed"
                : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>
        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: Number(e.target.value),
                page: 1,
              }));
            }}
            style={{
              padding: "5px 10px",
              margin: "0 10px",
                            backgroundColor:"rgb(239,239,239)",

            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Teacher;
